// extracted by mini-css-extract-plugin
export var cardSelected = "_hg-2";
export var image = "_hg-1";
export var table = "_hg-0";